import { Country } from "../../model/Country";
import { CurrentMenus, Destination } from "./models/Menus";

export const getMenuHasChanges = (
  currentMenus: CurrentMenus[] | undefined,
  newMenus: string[] | undefined
) => {
  // If one of them does not exists - should not happen
  if (!newMenus || !currentMenus) {
    return false;
  }

  // If both are empty, no changes
  if (currentMenus.length === 0 && newMenus.length === 0) {
    return false;
  }

  // When registering an input with no value to the array in RHF it publishes undefined as the first value
  // If undefined, then we treat it as an empty array
  if (currentMenus.length === 0 && !newMenus[0]) {
    return false;
  }

  // If both are the same, no changes
  // ? allows for currentMenus[0] to be undefined
  if (currentMenus[0]?.id === newMenus[0]) {
    return false;
  }

  // TODO: Add support for multiple menus when supported

  return true;
};

export const getSomeChildHasMenuChanges = (
  parentDestination: { id: string; menus: string[] },
  originDestinations: Destination[] | undefined,
  destinationsWithChanges: { id: string; menus: string[] }[]
) => {
  const children = originDestinations?.filter(
    (d) => d.parent === parentDestination.id
  );
  let someChildHasMenuChange = false;
  children?.forEach((child) => {
    const childInForm = destinationsWithChanges.find(
      (d) => d?.id === child?.id
    );
    const childHasChanges = getMenuHasChanges(
      child.currentMenus,
      childInForm?.menus
    );
    if (childHasChanges) {
      someChildHasMenuChange = true;
    }
  });
  return someChildHasMenuChange;
};

export const getHasChild = (
  destination: Destination,
  destinationsToFindChildIn: Destination[] | undefined
) => {
  const child = destinationsToFindChildIn?.find(
    (d) => d.parent === destination.id
  );
  const hasChild = !!child;
  return hasChild;
};

export const getCountryName = (
  countryCode: string | undefined,
  countries: Country[]
) => {
  const country = countries?.find((c) => c.countryCode === countryCode);
  return `${country?.englishName}`;
};

export const getCountryTextFlag = (countryCode: string | undefined) => {
  if (countryCode === "NO") {
    return "🇳🇴";
  } else if (countryCode === "SE") {
    return "🇸🇪";
  } else if (countryCode === "HR") {
    return "🇭🇷";
  } else if (countryCode === "AD") {
    return "🇦🇩";
  } else if (countryCode === "FI") {
    return "🇫🇮";
  } else {
    return "🇩🇰";
  }
};
